// Drop once we remove support for ie11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import {HelmetProvider} from 'react-helmet-async';
import {BrowserRouter as Router} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import {GlobalStyles, colorThemeGenerator} from '@spotify-internal/encore-web';
import {glueRoyalBlue} from '@spotify-internal/tokens/consumer/web/tokens.es6';

import 'lib/client/newrelic/new_relic';
import analytics from 'lib/client/analytics/analytics';
import resolver from 'lib/shared/experimentation/resolver';
import {initialize as initSentry} from 'lib/client/sentry/sentry';
import MarketInfoProvider, {initiateMarket, getLocaleForMarket} from 'context/MarketInfo/MarketInfoProvider';
import ConfigProvider from 'context/Config/ConfigProvider';
import ExperimentationProvider from 'context/Experimentation/ExperimentationProvider';
import UserInfoProvider from 'context/UserInfo/UserInfoProvider';
import {initI18n} from 'lib/shared/i18n/i18n';
import App from 'containers/App/App';

import './index.scss';

initSentry();

const market = initiateMarket();
initI18n(getLocaleForMarket(market));
analytics.initTracking(market);
resolver.market = market;

Modal.setAppElement('#root');

ReactDOM.render(
  <>
    <GlobalStyles noFonts />
    <Router basename={market}>
      <HelmetProvider>
        <MarketInfoProvider market={market}>
          <ConfigProvider>
            <UserInfoProvider>
              <ExperimentationProvider>
                <ThemeProvider theme={{...colorThemeGenerator({primaryColor: glueRoyalBlue})}}>
                  <App market={market} />
                </ThemeProvider>
              </ExperimentationProvider>
            </UserInfoProvider>
          </ConfigProvider>
        </MarketInfoProvider>
      </HelmetProvider>
    </Router>
  </>,
  document.getElementById('root')
);
